<template>
  <div class="page-container">
    <div class="query-title">积分申请查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :search-field="searchField" :loading="loading" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            show-overflow
            resizable
            height="500"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ height: 27, isCurrent: true }"
            :scroll-y="{ enabled: false }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            @filter-change="filterChangeEvt"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { getReverseIntegralList } from '@/api/sap/integral-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/pointApplyQuery'
import { frontExport, concurrencyReq } from '@/utils/frontExport'

export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50, fixed: 'left' }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions,
        ...this.pagination,
        sort: this.sortData.concat(this.tableSort)
      }
      // 如果点击查询，传入标识符，后端返回 过滤条件 和 计算数据
      params.is_result = 1
      this.loading = true
      try {
        const { data, total, calculation, field } = await getReverseIntegralList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
        this.$nextTick(() => {
          if (this.$refs.xTable && this.$refs.xTable.refreshScroll) {
            this.$refs.xTable.refreshScroll()
          }
        })
      } catch (e) {
        //
      }
      this.loading = false
    },
    async exportExcel() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getReverseIntegralList)
      frontExport(this.gridOptions.columns, data, '积分申请查询')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style lang="scss" scoped>
.query-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>




// WEBPACK FOOTER //
// src/views/integral-manage/pointApplyQuery.vue